<template>
  <div class="container mt-5">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h1 class="sect-title">Crônicas da Comunidade</h1>
      <button class="btn btn-vampire" @click="goToCreateChronicle" :disabled="!canCreateChronicle">
        <i class="bi bi-plus-circle-fill me-2"></i>
        Criar Crônica
      </button>
    </div>
    <div v-if="showCreateChronicleMessage" class="alert alert-warning">
        {{ createChronicleMessage }}
    </div>

    <div v-if="loading" class="text-center">
      <div class="spinner-border text-light" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div v-if="!loading && chronicles.length === 0" class="alert alert-vampire" role="alert">
      Nenhuma crônica foi encontrada. Seja o primeiro a criar uma!
    </div>

    <div class="row g-4">
      <div class="col-md-6 col-lg-4" v-for="chronicle in chronicles" :key="chronicle.id">
        <div class="card chronicle-card h-100" @click="goToChronicle(chronicle.id)">
          <div class="card-img-top" :style="{ backgroundImage: `url(${chronicle.cover_image_path || '/img/default-cover.jpg'})` }"></div>
          <div class="card-body">
            <h5 class="card-title">{{ chronicle.title }}</h5>
            <p class="card-text text-muted">{{ chronicle.synopsis }}</p>
          </div>
          <div class="card-footer">
            <small class="text-muted">Autor: {{ chronicle.author_name || 'Desconhecido' }}</small>
            <span :class="['badge', chronicle.status === 'finished' ? 'bg-success' : 'bg-warning']">
              {{ chronicle.status === 'finished' ? 'Finalizada' : 'Em Andamento' }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../services/api';

export default {
  name: 'ChroniclesListView',
  props: {
    currentUser: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      chronicles: [],
      loading: true,
    };
  },
  computed: {
    canCreateChronicle() {
      if (!this.currentUser) {
        return false;
      }
      if (this.currentUser.account_type === 'free') {
        return !this.chronicles.some(c => c.user_id === this.currentUser.id);
      }
      return true;
    },
    showCreateChronicleMessage() {
        if (!this.currentUser) {
            return true;
        }
        if (this.currentUser.account_type === 'free' && !this.canCreateChronicle) {
            return true;
        }
        return false;
    },
    createChronicleMessage() {
        if (!this.currentUser) {
            return 'Você precisa estar logado para criar uma crônica.';
        }
        if (this.currentUser.account_type === 'free' && !this.canCreateChronicle) {
            return 'Usuários gratuitos podem criar apenas uma crônica.';
        }
        return '';
    }
  },
  async created() {
    await this.fetchChronicles();
  },
  methods: {
    async fetchChronicles() {
      this.loading = true;
      try {
        const { data } = await api.get('/chronicles');
        this.chronicles = data;
      } catch (error) {
        console.error('Failed to fetch chronicles:', error);
      } finally {
        this.loading = false;
      }
    },
    goToChronicle(id) {
      if (!id) {
        return;
      }
      this.$router.push(`/cronicas/${id}`);
    },
    goToCreateChronicle() {
      this.$router.push('/cronicas/criar');
    },
  },
};
</script>

<style scoped>
.chronicle-card {
  cursor: pointer;
  transition: transform 0.2s;
}
.chronicle-card:hover {
  transform: scale(1.05);
}
.card-img-top {
  height: 200px;
  background-size: cover;
  background-position: center;
}
</style>
